// extracted by mini-css-extract-plugin
export default {"service":"solution_service__jOdr-","ind":"solution_ind__QWav2","case":"solution_case__9erMI","cardW":"solution_cardW__wJYc-","card":"solution_card__kvoW-"};